// Fixed order and return UI wording; backend values remain unchanged.
export const ordersDict: { en: Record<string, string>; ar: Record<string, string> } = {
  "en": {
    "order.new_order": "New Order",
    "order.payment_pending": "Payment Pending",
    "order.confirmed": "Confirmed",
    "order.in_production": "In Production",
    "order.quality_review": "Quality Review",
    "order.qa_review": "QA Review",
    "order.qa_approved": "QA Approved",
    "order.qa_rejected": "QA Rejected",
    "order.ready_for_delivery": "Ready for Delivery",
    "order.out_for_delivery": "Out for Delivery",
    "order.delivered": "Delivered",
    "order.cancelled": "Cancelled",
    "order.rejected": "Rejected",
    "returns.return_requested": "Return Requested",
    "returns.return_approved": "Return Approved",
    "returns.returned": "Returned",
    "order.sensation_formal": "Sensation (Formal)",
    "order.fresh_energy_outdoor": "Fresh Energy (Outdoor)",
    "order.casual_everyday": "Casual (Everyday)",
    "order.loading_invoice": "Loading invoice...",
    "order.customer": "Customer",
    "order.back_to_orders": "Back to Orders",
    "order.print_save_pdf": "Print / Save PDF",
    "order.reorder": "Reorder",
    "returns.return": "Return",
    "order.bespoke_perfumery": "Bespoke Perfumery",
    "order.tel": "Tel:",
    "order.trn": "TRN:",
    "order.invoice": "INVOICE",
    "order.bill_to": "Bill To",
    "order.ship_to": "Ship To",
    "order.n_a": "N/A",
    "order.description": "Description",
    "order.amount": "Amount",
    "order.anaya_collection": "Anaya Collection",
    "order.ai_crafted_perfume_collection": "AI-Crafted Perfume Collection",
    "order.order_code": "Order Code:",
    "order.item_code": "Item Code:",
    "order.signature_box": "Signature Box",
    "order.included": "Included",
    "order.sample": "Sample",
    "order.your_code": "Your Code:",
    "order.notes": "Notes:",
    "order.packaging": "Packaging:",
    "order.promo_discount": "Promo Discount (",
    "order.net_amount_paid": "Net Amount Paid",
    "order.greeting_message": "Greeting Message:",
    "order.subtotal_gross": "Subtotal (Gross)",
    "order.discount": "Discount (",
    "order.net_subtotal": "Net Subtotal",
    "order.vat_0": "VAT (0%)",
    "order.total": "Total",
    "order.order_number": "Order Number",
    "order.collection_code": "= Collection Code",
    "order.order_date": "Order Date",
    "order.special_requests": "Special Requests",
    "order.thank_you_for_choosing_anaya_your_bespoke_fragrance_was_crafted_with_care": "Thank you for choosing ANAYA. Your bespoke fragrance was crafted with care.",
    "order.love_this_fragrance": "Love this fragrance?",
    "order.reorder_your_personalized_collection_with_one_click": "Reorder your personalized collection with one click",
    "order.reorder_now": "Reorder Now",
    "returns.need_to_return_this_order": "Need to return this order?",
    "returns.request_return": "Request Return",
    "returns.return_already_requested": "Return already requested",
    "returns.a_return_request_has_already_been_submitted_for_this_order_only_one_return_request_is_allowed_per_order": "A return request has already been submitted for this order. Only one return request is allowed per order.",
    "order.top_notes": "Top Notes",
    "order.heart_notes": "Heart Notes",
    "order.base_notes": "Base Notes",
    "order.your_perfume_code": "Your Perfume Code",
    "order.loading_order_details": "Loading order details...",
    "order.order_not_found": "Order not found",
    "order.order_client_overview": "Order & Client Overview",
    "order.invoice_number": "Invoice Number",
    "order.pending": "Pending",
    "order.status": "Status",
    "order.system_perfume_code": "System Perfume Code",
    "order.anaya_perfume_code": "Anaya Perfume Code",
    "order.full_name": "Full Name",
    "order.email": "Email",
    "order.phone": "Phone",
    "order.gift_recipient": "Gift Recipient",
    "order.shipping_address": "Shipping Address",
    "order.quiz_selections": "Quiz Selections",
    "order.gender": "Gender",
    "order.personality": "Personality",
    "order.nature": "Nature",
    "order.style": "Style",
    "order.age_bracket": "Age Bracket",
    "order.skin_type": "Skin Type",
    "order.package_type": "Package Type",
    "order.single": "Single",
    "order.no_quiz_data_available": "No quiz data available",
    "order.perfume_selection": "Perfume Selection",
    "order.no_perfumes_selected": "No perfumes selected",
    "order.arabic": "Arabic",
    "order.system": "System:",
    "order.anaya": "Anaya:",
    "order.match": "% match",
    "order.match_breakdown": "Match Breakdown (",
    "order.age": "Age",
    "order.detailed_breakdown_not_available_for_this_recommendation": "Detailed breakdown not available for this recommendation",
    "order.per_recipient_breakdown": "Per-Recipient Breakdown (",
    "order.orders_in_this_purchase": "orders in this purchase)",
    "order.this_payment_includes_multiple_personalized_boxes_each_box_s_recipient_greeting_photo_and_perfumes_are_shown_separately_below": "This payment includes multiple personalized boxes. Each box's recipient, greeting, photo and perfumes are shown separately below.",
    "order.order": "Order:",
    "order.of": "of",
    "order.recipient": "Recipient",
    "order.country": "Country",
    "order.greeting_note": "Greeting Note",
    "returns.uploaded_photo": "Uploaded Photo",
    "order.perfumes_for_this_order": "Perfumes for this Order",
    "order.items_purchased": "Items Purchased",
    "order.box_code": "Box Code:",
    "order.qty": "Qty:",
    "order.free_sample": "Free Sample",
    "order.included_perfumes": "Included Perfumes:",
    "order.code": "Code:",
    "order.ml": "ml",
    "order.order_total": "Order Total",
    "order.special_notes": "Special Notes",
    "order.important": "Important",
    "order.special_notes_from_customer": "Special Notes from Customer",
    "order.please_consider_these_notes_when_preparing_this_order": "⚠️ Please consider these notes when preparing this order",
    "order.no_special_requests": "No special requests.",
    "returns.uploaded_images": "Uploaded Images",
    "order.production_timeline": "Production Timeline",
    "order.order_created": "Order Created",
    "order.production_started": "Production Started",
    "order.production_completed": "Production Completed",
    "order.qa_reviewed": "QA Reviewed",
    "returns.rejection_reason": "Rejection Reason",
    "order.internal_notes": "Internal Notes",
    "order.actions": "Actions",
    "order.pending_review": "Pending Review",
    "order.approved": "Approved",
    "order.not_approved": "Not Approved",
    "returns.refund_pending": "Refund Pending",
    "returns.refund_completed": "Refund Completed",
    "returns.return_request": "Return Request",
    "order.date": "Date:",
    "returns.items_being_returned": "Items Being Returned",
    "returns.return_reason": "Return Reason",
    "order.not_specified": "Not specified",
    "returns.return_evidence": "Return evidence",
    "returns.refund_details": "Refund Details",
    "returns.return_method": "Return Method:",
    "returns.refund_amount": "Refund Amount:",
    "order.to_be_confirmed": "To be confirmed",
    "order.messages": "Messages",
    "order.close": "Close",
    "returns.no_return_requests": "No Return Requests",
    "returns.you_haven_t_submitted_any_return_requests_yet": "You haven't submitted any return requests yet.",
    "returns.how_to_request_a_return": "How to Request a Return",
    "returns.to_initiate_a_return_go_to_the": "To initiate a return, go to the",
    "order.orders": "Orders",
    "order.tab_find_your_delivered_order_click_on": "tab, find your delivered order, click on",
    "order.view_details": "View Details",
    "order.and_select": ", and select",
    "returns.returns_are_available_within_the_eligibility_period_after_delivery": ". Returns are available within the eligibility period after delivery.",
    "returns.my_returns": "My Returns",
    "returns.track_your_return_requests": "Track your return requests",
    "order.new": "new",
    "order.item_s": "item(s)",
    "order.invalid_file_type": "Invalid file type",
    "order.file_too_large": "File too large",
    "order.please_select_items": "Please select items",
    "returns.select_at_least_one_item_to_return": "Select at least one item to return",
    "returns.please_select_a_reason": "Please select a reason",
    "returns.select_a_reason_for_your_return": "Select a reason for your return",
    "order.details_required": "Details required",
    "returns.please_provide_details_for_your_return_reason": "Please provide details for your return reason",
    "returns.your_return_request_has_been_initiated_anaya_will_get_back_to_you_within_3_working_days": "Your return request has been initiated. Anaya will get back to you within 3 working days.",
    "returns.return_request_submitted": "Return Request Submitted",
    "order.error": "Error",
    "returns.failed_to_submit_return_request_please_try_again": "Failed to submit return request. Please try again.",
    "returns.return_type": "Return Type",
    "returns.choose_how_you_want_to_return_your_signature_box": "Choose how you want to return your Signature Box",
    "returns.return_entire_box": "Return Entire Box",
    "returns.return_all": "Return all",
    "order.perfumes_from_your_signature_box": "perfumes from your Signature Box",
    "returns.refund_aed": "Refund: AED",
    "returns.return_individual_bottles": "Return Individual Bottles",
    "returns.select_specific_perfume_bottles_to_return_50ml_each": "Select specific perfume bottles to return (50ml each)",
    "order.per_bottle": "per bottle",
    "returns.select_items_to_return": "Select Items to Return",
    "returns.all_items_from_your_signature_box_will_be_returned": "All items from your Signature Box will be returned",
    "returns.choose_the_items_you_wish_to_return": "Choose the items you wish to return",
    "returns.estimated_refund": "Estimated Refund:",
    "returns.why_are_you_returning_this_item": "Why are you returning this item?",
    "order.please_provide_details": "Please provide details",
    "returns.please_describe_your_reason_for_returning": "Please describe your reason for returning...",
    "returns.upload_images_optional": "Upload Images (Optional)",
    "returns.add_photos_to_support_your_return_request_max_5_images_5mb_each": "Add photos to support your return request (max 5 images, 5MB each)",
    "returns.click_to_upload_images": "Click to upload images",
    "order.cancel": "Cancel",
    "returns.uploading": "Uploading...",
    "order.submitting": "Submitting...",
    "returns.submit_return_request": "Submit Return Request",
    "order.no_order_or_product_found_with_this_code_please_check_and_try_again": "No order or product found with this code. Please check and try again.",
    "order.an_error_occurred_please_try_again": "An error occurred. Please try again.",
    "order.please_enter_your_item_code": "Please enter your item code",
    "order.added_to_cart": "Added to Cart!",
    "order.sign_in_required": "Sign in required",
    "order.please_sign_in_to_reorder_collection_items": "Please sign in to reorder collection items.",
    "order.failed_to_add_item_to_cart_please_try_again": "Failed to add item to cart. Please try again.",
    "order.failed_to_add_items_to_cart_please_try_again": "Failed to add items to cart. Please try again.",
    "order.quick_reorder": "Quick Reorder",
    "order.loading": "Loading...",
    "order.per_perfume": "per perfume",
    "order.e_g_an260101_or_sc260101": "e.g., AN260101 or SC260101",
    "order.find_your_code_on_the_bottle_or_your_previous_order_confirmation": "Find your code on the bottle or your previous order confirmation.",
    "order.product_found": "Product Found",
    "order.select_size": "Select Size",
    "order.top": "Top:",
    "order.heart": "Heart:",
    "order.base": "Base:",
    "order.re_order_your_collection": "Re-order Your Collection",
    "order.re_order_your_perfume": "Re-order Your Perfume",
    "order.enter_your_item_code_to_quickly_re_order": "Enter your item code to quickly re-order.",
    "order.select_the_collection_items_you_d_like_to_reorder": "Select the collection items you'd like to reorder.",
    "order.this_is_a_collection_code_select_one_or_more_perfumes_from_your_original_order": "This is a collection code. Select one or more perfumes from your original order.",
    "order.confirm_your_perfume_reorder": "Confirm your perfume reorder.",
    "order.your_personalized_fragrance_will_be_crafted_exactly_as_before": "Your personalized fragrance will be crafted exactly as before.",
    "order.perfume_code": "Perfume Code",
    "order.individual_perfume_code": "= Individual Perfume Code •",
    "order.finding_your_order": "Finding Your Order...",
    "order.find_my_perfume": "Find My Perfume",
    "order.this_is_a_signature_box_confirm_your_reorder_below": "This is a Signature Box. Confirm your reorder below.",
    "order.select_your_preferred_size_and_confirm": "Select your preferred size and confirm.",
    "order.collection_order": "Collection Order",
    "order.confirm_your_perfume_reorder_below": "Confirm your perfume reorder below.",
    "order.found": "Found",
    "order.your_personalized_perfume": "Your Personalized Perfume",
    "order.back": "Back",
    "order.adding": "Adding...",
    "order.add_to_cart_checkout": "Add to Cart & Checkout",
    "order.name_is_not_a_supported_image_format": "{name} is not a supported image format",
    "order.name_exceeds_5mb_limit": "{name} exceeds 5MB limit",
    "order.upload_number": "Upload {number}",
    "order.recipient_number_photo": "Recipient {number} photo",
    "order.re_order_name": "Re-order {name}",
    "order.confirm_your_reorder_for_name": "Confirm your reorder for {name}.",
    "order.name_has_been_added_to_your_cart": "{name} has been added to your cart.",
    "order.count_items_added_to_your_cart": "{count} items added to your cart.",
    "order.your_perfume_has_been_added_to_your_cart": "Your perfume has been added to your cart.",
    "order.you_have_count_days_left_to_initiate_a_return": "You have {count} days left to initiate a return",
    "returns.remove_image": "Remove image"
  },
  "ar": {
    "order.new_order": "طلب جديد",
    "order.payment_pending": "بانتظار الدفع",
    "order.confirmed": "مؤكد",
    "order.in_production": "قيد الإنتاج",
    "order.quality_review": "مراجعة الجودة",
    "order.qa_review": "مراجعة الجودة",
    "order.qa_approved": "تم اعتماد الجودة",
    "order.qa_rejected": "لم يجتز مراجعة الجودة",
    "order.ready_for_delivery": "جاهز للتوصيل",
    "order.out_for_delivery": "في الطريق للتوصيل",
    "order.delivered": "تم التوصيل",
    "order.cancelled": "ملغى",
    "order.rejected": "مرفوض",
    "returns.return_requested": "تم طلب الإرجاع",
    "returns.return_approved": "تمت الموافقة على الإرجاع",
    "returns.returned": "تم الإرجاع",
    "order.sensation_formal": "إحساس (للمناسبات الرسمية)",
    "order.fresh_energy_outdoor": "طاقة منعشة (للأنشطة الخارجية)",
    "order.casual_everyday": "عفوي (للاستخدام اليومي)",
    "order.loading_invoice": "جارٍ تحميل الفاتورة...",
    "order.customer": "العميل",
    "order.back_to_orders": "العودة إلى الطلبات",
    "order.print_save_pdf": "طباعة / حفظ بصيغة PDF",
    "order.reorder": "إعادة الطلب",
    "returns.return": "إرجاع",
    "order.bespoke_perfumery": "عطور مصممة خصيصًا لك",
    "order.tel": "الهاتف:",
    "order.trn": "رقم التسجيل الضريبي:",
    "order.invoice": "فاتورة",
    "order.bill_to": "بيانات الفوترة",
    "order.ship_to": "عنوان الشحن",
    "order.n_a": "غير متوفر",
    "order.description": "الوصف",
    "order.amount": "المبلغ",
    "order.anaya_collection": "مجموعة أنايا",
    "order.ai_crafted_perfume_collection": "مجموعة عطور مصممة بالذكاء الاصطناعي",
    "order.order_code": "رمز الطلب:",
    "order.item_code": "رمز المنتج:",
    "order.signature_box": "علبة سيغنتشر",
    "order.included": "مشمول",
    "order.sample": "عينة",
    "order.your_code": "رمزك:",
    "order.notes": "النفحات:",
    "order.packaging": "التغليف:",
    "order.promo_discount": "خصم ترويجي (",
    "order.net_amount_paid": "صافي المبلغ المدفوع",
    "order.greeting_message": "رسالة الإهداء:",
    "order.subtotal_gross": "المجموع الفرعي (الإجمالي)",
    "order.discount": "خصم (",
    "order.net_subtotal": "صافي المجموع الفرعي",
    "order.vat_0": "ضريبة القيمة المضافة (0%)",
    "order.total": "الإجمالي",
    "order.order_number": "رقم الطلب",
    "order.collection_code": "= رمز المجموعة",
    "order.order_date": "تاريخ الطلب",
    "order.special_requests": "طلبات خاصة",
    "order.thank_you_for_choosing_anaya_your_bespoke_fragrance_was_crafted_with_care": "شكرًا لاختيارك أنايا. صُنع عطرك الخاص بعناية.",
    "order.love_this_fragrance": "هل أعجبك هذا العطر؟",
    "order.reorder_your_personalized_collection_with_one_click": "أعد طلب مجموعتك المخصصة بنقرة واحدة",
    "order.reorder_now": "أعد الطلب الآن",
    "returns.need_to_return_this_order": "هل ترغب في إرجاع هذا الطلب؟",
    "returns.request_return": "طلب إرجاع",
    "returns.return_already_requested": "تم طلب الإرجاع مسبقًا",
    "returns.a_return_request_has_already_been_submitted_for_this_order_only_one_return_request_is_allowed_per_order": "تم تقديم طلب إرجاع لهذا الطلب مسبقًا. يُسمح بطلب إرجاع واحد فقط لكل طلب.",
    "order.top_notes": "النفحات العليا",
    "order.heart_notes": "نفحات القلب",
    "order.base_notes": "النفحات القاعدية",
    "order.your_perfume_code": "رمز عطرك",
    "order.loading_order_details": "جارٍ تحميل تفاصيل الطلب...",
    "order.order_not_found": "لم يتم العثور على الطلب",
    "order.order_client_overview": "ملخص الطلب والعميل",
    "order.invoice_number": "رقم الفاتورة",
    "order.pending": "قيد الانتظار",
    "order.status": "الحالة",
    "order.system_perfume_code": "رمز العطر في النظام",
    "order.anaya_perfume_code": "رمز عطر أنايا",
    "order.full_name": "الاسم الكامل",
    "order.email": "البريد الإلكتروني",
    "order.phone": "الهاتف",
    "order.gift_recipient": "مستلم الهدية",
    "order.shipping_address": "عنوان الشحن",
    "order.quiz_selections": "اختيارات الاستبيان",
    "order.gender": "الجنس",
    "order.personality": "الشخصية",
    "order.nature": "الطبيعة",
    "order.style": "الأسلوب",
    "order.age_bracket": "الفئة العمرية",
    "order.skin_type": "نوع البشرة",
    "order.package_type": "نوع العبوة",
    "order.single": "فردي",
    "order.no_quiz_data_available": "لا تتوفر بيانات الاستبيان",
    "order.perfume_selection": "العطور المختارة",
    "order.no_perfumes_selected": "لم يتم اختيار عطور",
    "order.arabic": "العربية",
    "order.system": "النظام:",
    "order.anaya": "أنايا:",
    "order.match": "% تطابق",
    "order.match_breakdown": "تفاصيل التطابق (",
    "order.age": "العمر",
    "order.detailed_breakdown_not_available_for_this_recommendation": "لا تتوفر تفاصيل التطابق لهذه التوصية",
    "order.per_recipient_breakdown": "التفاصيل حسب المستلم (",
    "order.orders_in_this_purchase": "طلبات في عملية الشراء هذه)",
    "order.this_payment_includes_multiple_personalized_boxes_each_box_s_recipient_greeting_photo_and_perfumes_are_shown_separately_below": "تشمل هذه الدفعة عدة علب مخصصة. تُعرض أدناه بيانات المستلم ورسالة الإهداء والصورة والعطور لكل علبة على حدة.",
    "order.order": "الطلب:",
    "order.of": "من",
    "order.recipient": "المستلم",
    "order.country": "الدولة",
    "order.greeting_note": "رسالة الإهداء",
    "returns.uploaded_photo": "الصورة المرفوعة",
    "order.perfumes_for_this_order": "عطور هذا الطلب",
    "order.items_purchased": "المنتجات المشتراة",
    "order.box_code": "رمز العلبة:",
    "order.qty": "الكمية:",
    "order.free_sample": "عينة مجانية",
    "order.included_perfumes": "العطور المشمولة:",
    "order.code": "الرمز:",
    "order.ml": "مل",
    "order.order_total": "إجمالي الطلب",
    "order.special_notes": "ملاحظات خاصة",
    "order.important": "مهم",
    "order.special_notes_from_customer": "ملاحظات خاصة من العميل",
    "order.please_consider_these_notes_when_preparing_this_order": "⚠️ يرجى مراعاة هذه الملاحظات عند تحضير الطلب",
    "order.no_special_requests": "لا توجد طلبات خاصة.",
    "returns.uploaded_images": "الصور المرفوعة",
    "order.production_timeline": "مراحل الإنتاج",
    "order.order_created": "تم إنشاء الطلب",
    "order.production_started": "بدأ الإنتاج",
    "order.production_completed": "اكتمل الإنتاج",
    "order.qa_reviewed": "تمت مراجعة الجودة",
    "returns.rejection_reason": "سبب الرفض",
    "order.internal_notes": "ملاحظات داخلية",
    "order.actions": "الإجراءات",
    "order.pending_review": "بانتظار المراجعة",
    "order.approved": "تمت الموافقة",
    "order.not_approved": "لم تتم الموافقة",
    "returns.refund_pending": "بانتظار استرداد المبلغ",
    "returns.refund_completed": "تم استرداد المبلغ",
    "returns.return_request": "طلب إرجاع",
    "order.date": "التاريخ:",
    "returns.items_being_returned": "المنتجات المراد إرجاعها",
    "returns.return_reason": "سبب الإرجاع",
    "order.not_specified": "غير محدد",
    "returns.return_evidence": "صور توثيق الإرجاع",
    "returns.refund_details": "تفاصيل استرداد المبلغ",
    "returns.return_method": "طريقة الإرجاع:",
    "returns.refund_amount": "مبلغ الاسترداد:",
    "order.to_be_confirmed": "سيتم التأكيد لاحقًا",
    "order.messages": "الرسائل",
    "order.close": "إغلاق",
    "returns.no_return_requests": "لا توجد طلبات إرجاع",
    "returns.you_haven_t_submitted_any_return_requests_yet": "لم تقدم أي طلبات إرجاع بعد.",
    "returns.how_to_request_a_return": "كيفية طلب الإرجاع",
    "returns.to_initiate_a_return_go_to_the": "لبدء الإرجاع، انتقل إلى علامة تبويب",
    "order.orders": "الطلبات",
    "order.tab_find_your_delivered_order_click_on": "وابحث عن طلبك الذي تم توصيله، ثم اضغط على",
    "order.view_details": "عرض التفاصيل",
    "order.and_select": "، واختر",
    "returns.returns_are_available_within_the_eligibility_period_after_delivery": ". يتوفر الإرجاع خلال فترة الأهلية بعد التوصيل.",
    "returns.my_returns": "طلبات الإرجاع",
    "returns.track_your_return_requests": "تابع طلبات الإرجاع الخاصة بك",
    "order.new": "جديدة",
    "order.item_s": "منتجًا",
    "order.invalid_file_type": "نوع الملف غير صالح",
    "order.file_too_large": "حجم الملف كبير جدًا",
    "order.please_select_items": "يرجى اختيار المنتجات",
    "returns.select_at_least_one_item_to_return": "اختر منتجًا واحدًا على الأقل لإرجاعه",
    "returns.please_select_a_reason": "يرجى اختيار السبب",
    "returns.select_a_reason_for_your_return": "اختر سببًا للإرجاع",
    "order.details_required": "التفاصيل مطلوبة",
    "returns.please_provide_details_for_your_return_reason": "يرجى تقديم تفاصيل سبب الإرجاع",
    "returns.your_return_request_has_been_initiated_anaya_will_get_back_to_you_within_3_working_days": "تم تسجيل طلب الإرجاع. ستتواصل معك أنايا خلال 3 أيام عمل.",
    "returns.return_request_submitted": "تم تقديم طلب الإرجاع",
    "order.error": "خطأ",
    "returns.failed_to_submit_return_request_please_try_again": "تعذر تقديم طلب الإرجاع. يرجى المحاولة مجددًا.",
    "returns.return_type": "نوع الإرجاع",
    "returns.choose_how_you_want_to_return_your_signature_box": "اختر طريقة إرجاع علبة سيغنتشر",
    "returns.return_entire_box": "إرجاع العلبة بالكامل",
    "returns.return_all": "إرجاع جميع",
    "order.perfumes_from_your_signature_box": "عطور علبة سيغنتشر",
    "returns.refund_aed": "مبلغ الاسترداد: AED",
    "returns.return_individual_bottles": "إرجاع زجاجات منفردة",
    "returns.select_specific_perfume_bottles_to_return_50ml_each": "اختر زجاجات العطر المراد إرجاعها (50 مل لكل زجاجة)",
    "order.per_bottle": "لكل زجاجة",
    "returns.select_items_to_return": "اختر المنتجات المراد إرجاعها",
    "returns.all_items_from_your_signature_box_will_be_returned": "سيتم إرجاع جميع منتجات علبة سيغنتشر",
    "returns.choose_the_items_you_wish_to_return": "اختر المنتجات التي ترغب في إرجاعها",
    "returns.estimated_refund": "مبلغ الاسترداد التقديري:",
    "returns.why_are_you_returning_this_item": "ما سبب إرجاع هذا المنتج؟",
    "order.please_provide_details": "يرجى تقديم التفاصيل",
    "returns.please_describe_your_reason_for_returning": "يرجى توضيح سبب الإرجاع...",
    "returns.upload_images_optional": "رفع الصور (اختياري)",
    "returns.add_photos_to_support_your_return_request_max_5_images_5mb_each": "أضف صورًا لدعم طلب الإرجاع (5 صور كحد أقصى، 5 ميغابايت لكل صورة)",
    "returns.click_to_upload_images": "اضغط لرفع الصور",
    "order.cancel": "إلغاء",
    "returns.uploading": "جارٍ الرفع...",
    "order.submitting": "جارٍ الإرسال...",
    "returns.submit_return_request": "إرسال طلب الإرجاع",
    "order.no_order_or_product_found_with_this_code_please_check_and_try_again": "لم يتم العثور على طلب أو منتج بهذا الرمز. يرجى التحقق والمحاولة مجددًا.",
    "order.an_error_occurred_please_try_again": "حدث خطأ. يرجى المحاولة مجددًا.",
    "order.please_enter_your_item_code": "يرجى إدخال رمز المنتج",
    "order.added_to_cart": "تمت الإضافة إلى السلة!",
    "order.sign_in_required": "يلزم تسجيل الدخول",
    "order.please_sign_in_to_reorder_collection_items": "يرجى تسجيل الدخول لإعادة طلب منتجات المجموعة.",
    "order.failed_to_add_item_to_cart_please_try_again": "تعذرت إضافة المنتج إلى السلة. يرجى المحاولة مجددًا.",
    "order.failed_to_add_items_to_cart_please_try_again": "تعذرت إضافة المنتجات إلى السلة. يرجى المحاولة مجددًا.",
    "order.quick_reorder": "إعادة الطلب سريعًا",
    "order.loading": "جارٍ التحميل...",
    "order.per_perfume": "لكل عطر",
    "order.e_g_an260101_or_sc260101": "مثال: AN260101 أو SC260101",
    "order.find_your_code_on_the_bottle_or_your_previous_order_confirmation": "ستجد الرمز على الزجاجة أو في تأكيد طلبك السابق.",
    "order.product_found": "تم العثور على المنتج",
    "order.select_size": "اختر الحجم",
    "order.top": "النفحات العليا:",
    "order.heart": "نفحات القلب:",
    "order.base": "النفحات القاعدية:",
    "order.re_order_your_collection": "أعد طلب مجموعتك",
    "order.re_order_your_perfume": "أعد طلب عطرك",
    "order.enter_your_item_code_to_quickly_re_order": "أدخل رمز المنتج لإعادة الطلب سريعًا.",
    "order.select_the_collection_items_you_d_like_to_reorder": "اختر منتجات المجموعة التي ترغب في إعادة طلبها.",
    "order.this_is_a_collection_code_select_one_or_more_perfumes_from_your_original_order": "هذا رمز مجموعة. اختر عطرًا واحدًا أو أكثر من طلبك الأصلي.",
    "order.confirm_your_perfume_reorder": "أكد إعادة طلب عطرك.",
    "order.your_personalized_fragrance_will_be_crafted_exactly_as_before": "سيُصنع عطرك المخصص تمامًا كما كان من قبل.",
    "order.perfume_code": "رمز العطر",
    "order.individual_perfume_code": "= رمز عطر فردي •",
    "order.finding_your_order": "جارٍ البحث عن طلبك...",
    "order.find_my_perfume": "اعثر على عطري",
    "order.this_is_a_signature_box_confirm_your_reorder_below": "هذه علبة سيغنتشر. أكد إعادة الطلب أدناه.",
    "order.select_your_preferred_size_and_confirm": "اختر الحجم المفضل وأكد الطلب.",
    "order.collection_order": "طلب من المجموعة",
    "order.confirm_your_perfume_reorder_below": "أكد إعادة طلب عطرك أدناه.",
    "order.found": "تم العثور على",
    "order.your_personalized_perfume": "عطرك المخصص",
    "order.back": "رجوع",
    "order.adding": "جارٍ الإضافة...",
    "order.add_to_cart_checkout": "أضف إلى السلة وانتقل للدفع",
    "order.name_is_not_a_supported_image_format": "تنسيق صورة {name} غير مدعوم",
    "order.name_exceeds_5mb_limit": "يتجاوز {name} الحد الأقصى البالغ 5 ميغابايت",
    "order.upload_number": "الصورة المرفوعة {number}",
    "order.recipient_number_photo": "صورة المستلم {number}",
    "order.re_order_name": "أعد طلب {name}",
    "order.confirm_your_reorder_for_name": "أكد إعادة طلب {name}.",
    "order.name_has_been_added_to_your_cart": "تمت إضافة {name} إلى سلتك.",
    "order.count_items_added_to_your_cart": "تمت إضافة {count} من المنتجات إلى سلتك.",
    "order.your_perfume_has_been_added_to_your_cart": "تمت إضافة عطرك إلى سلتك.",
    "order.you_have_count_days_left_to_initiate_a_return": "لديك {count} يومًا لبدء طلب الإرجاع",
    "returns.remove_image": "إزالة الصورة"
  }
};
